mutation CopyCampaign(
    $campaignId: ID!
    $name: String!
    $masterTemplateIds: [ID!]!
    $languages: [String!]!
    $sectionId: ID
    $opendcPlatformSettings: SCALAR_MIXED
) {
    copyCampaign(
        campaignId: $campaignId
        name: $name
        masterTemplateIds: $masterTemplateIds
        languages: $languages
        sectionId: $sectionId
        opendcPlatformSettings: $opendcPlatformSettings
    ) {
        _id
    }
}
